import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Container, Image, Row, Col, Carousel, Card } from 'react-bootstrap';
import piazzacima from '../assets/piazzacima.jpg';
import castello2 from '../assets/castello2.jpg';
import pozzo from '../assets/pozzo.jpg';
import viaxx from '../assets/viaxx.jpg';
import teamTED from '../assets/TeamTEDxConegliano.jpg';
import icona1 from '../assets/Icona_1.svg';
import icona2 from '../assets/Icona_2.svg';
import icona3 from '../assets/Icona_3.svg';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import coverHeritage from '../assets/heritage/cover.jpg';
import coverInvisibile from '../assets/invisibile/cover.jpg';
import coverPalindromo from '../assets/palindromo/cover.jpg';
import HeroTedx2026 from '../assets/palindromo/HeroTedx2026.jsx';



export default function Home() {

    return (
        <>
            <Helmet>
                <title>TEDxConegliano</title>
                <meta name="description" content="TEDxConegliano" />
            </Helmet>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100 slide-gradient-red align-items-end' style={{ backgroundColor: '#eee', backgroundImage: 'url(' + piazzacima + ')' }}>
                <Container fluid="md" className='text-start p-5 text-white' style={{ zIndex: 1 }}>
                    <h5>TEDxConegliano</h5>
                    <h1 className='mt-5 mb-5' style={{ maxWidth: 700 }}>
                        Dove l'incanto della nostra città, ora Patrimonio UNESCO, si unisce alla forza delle idee.
                    </h1>

                    <p style={{ maxWidth: 700 }} className='lead'>
                        Attraverso sfide e innovazioni, ci dobbiamo far ispirare, costruendo
                        una comunità di pensatori audaci che arricchiscono il tessuto
                        culturale e sociale del nostro territorio
                    </p>

                    <div className='mt-5 mb-5'>
                        <Link to="/edition/palindromo">
                            <span className='button-52-light m-auto'>
                                Next Event
                            </span>
                        </Link>
                    </div>
                </Container>
            </Container>


            <Container fluid className='mt-5 pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-start px-5'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={4} className='pb-5'>
                            <Image src={icona1} height={100} className='mb-5' />
                            <p>
                                L'eccellenza del territorio si unisce alla visione globale di TED
                            </p>
                        </Col>
                        <Col xs={12} lg={4} className='pb-5'>
                            <Image src={icona2} height={100} className='mb-5' />
                            <p>
                                L'eredità artistica e storica di Conegliano è il trampolino di lancio per un'innovazione senza confini
                            </p>
                        </Col>
                        <Col xs={12} lg={4} className='pb-5'>
                            <Image src={icona3} height={100} className='mb-5' />
                            <p>
                                Il suggestivo paesaggio e il ricco patrimonio di Conegliano fungono da amplificatore per le nostre idee
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-center'>
                        <Col xs={12} lg={6} className='text-center'>
                            <Image src={pozzo} width={'100%'} className='mb-5' />
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={5}>
                            <h5 style={{ color: '#eb0028' }}>TEDxConegliano</h5>
                            <h3 className='mt-5 mb-5' style={{ maxWidth: 700 }}>Perchè proprio a Conegliano?</h3>

                            <p className='mb-5 lead'>Conegliano è un luogo intriso di storia, cultura e innovazione, il che lo rende la cornice perfetta per un evento TEDx.</p>
                            <p style={{ maxWidth: 600 }}>
                                La città e le sue colline, recentemente insigniti del
                                prestigioso titolo di Patrimonio UNESCO, offrono un
                                ambiente unico che incarna la fusione tra tradizione e
                                modernità.
                            </p>

                            <div className='mt-5 mb-5'>
                                <Link to="/edition/palindromo">
                                    <span className='button-52 m-auto'>
                                        Next Event
                                    </span>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100 slide-gradient-black' style={{ backgroundColor: '#eee', backgroundImage: 'url(' + castello2 + ')' }}>
                <Container fluid="md" className='text-start p-5 text-white' style={{ zIndex: 1 }}>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={2} className='pb-5'>
                            <h5 style={{ color: '#eb0028' }}>TEDxConegliano</h5>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={3} className='pb-5'>
                            <p className='lead'>
                                Il format TED vuole essere un luogo
                                di incontro e di stimolo verso un
                                futuro in costante evoluzione, così da
                                preparare la città e tutti i suoi attori
                                alla sfide future che ella stessa si è
                                data.
                            </p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={5} className='pb-5'>
                            <p>
                                Un palco che ospiterà speaker locali che rendono grande la
                                città nel mondo ma anche personalità che possono dare
                                una visione e uno stimolo nuovo alla città.
                                <br /><br />
                                Stimolare la città ad innovarsi, aprirsi e rendersi attrattiva
                                anche verso i giovani attraverso la Valorizzazione dei tanti
                                talenti che ci vivono, spesso però costretti a spostarsi per
                                trovare la loro piena maturità ma con la volontà di ritornare
                                nella loro città natale.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={2} className='pb-5'>
                            <h5 style={{ color: '#eb0028' }}>TEDxConegliano</h5>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={3} className='pb-5'>
                            <Image src={viaxx} width={'100%'} />
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={5} className='pb-5'>
                            <p className='mb-5 lead'>
                                Immersa tra paesaggi mozzafiato e circondata
                                da un ricco patrimonio artistico, Conegliano
                                deve attrarre menti creative e appassionate da
                                tutto il mondo.
                            </p>
                            <p>
                                La sua posizione strategica nel cuore del Veneto, rinomato
                                per la sua eccellenza enogastronomica e il suo fervore
                                culturale, la rende un crocevia ideale per l'incontro e lo
                                scambio di idee.
                                <br /><br />
                                Organizzare un evento TEDx a Conegliano non solo
                                celebra e condivide la bellezza e l'innovazione di questa
                                città, ma anche offre un trampolino per idee nuove e
                                fresche che possono ispirare e trasformare il territorio,
                                promuovendo un dialogo costruttivo che porta alla crescita
                                e al miglioramento della comunità.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <HeroTedx2026 ticketUrl="https://www.eventbrite.it/e/biglietti-tedxconegliano-palindromo-1982234216903" />

            {/* Sezione PALINDROMO precedente — sostituita da <HeroTedx2026 />.
                Tenuta commentata come backup.
            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100 slide-gradient-light' style={{ backgroundSize: 'inherit', backgroundRepeat: 'repeat', backgroundColor: '#000' }}>
                <Container fluid="md" className='text-center p-5 text-white' style={{ zIndex: 1 }}>
                    <h1 className='mt-5 mb-5'>
                        PALINDROMO - Apparente uguale, reale diverso.
                    </h1>

                    <p className='m-auto' style={{ maxWidth: 800 }}>
                        Ciò che sembra uguale non lo è mai davvero.<br/>
                        Ogni forma contiene più letture, ogni idea più direzioni.<br/>
                        Con questa edizione di TEDxConegliano esploriamo come il significato cambi a seconda di come lo attraversiamo, perché basta uno spostamento, anche minimo, per vedere qualcosa di completamente diverso.
                    </p>

                    <div className='mt-5 mb-5'>
                        <Link to="/edition/palindromo">
                            <span className='button-52-light red m-auto'>
                                Scopri
                            </span>
                        </Link>
                    </div>

                </Container>
            </Container>
            */}


            <Container fluid className='pt-5 pb-5 ps-0 pe-0' style={{ backgroundColor: '#eee' }}>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={3} className='text-start mt-4 mb-5'>
                            <h5 style={{ color: '#eb0028' }}>EVENTI</h5>
                            <p className='mt-5'>
                                Ogni evento TEDxConegliano è una tappa di un cammino, un luogo in cui le idee si incontrano, si trasformano e lasciano il loro segno.
                            </p>
                        </Col>
                        <Col xs={12} lg={2}></Col>
                        <Col xs={12} lg={7} className='text-center'>
                            <Row>
                                <Col xs={12} md={12}>
                                    <Card style={{ maxWidth: 400, margin: 'auto' }}>
                                        <Card.Body style={{ padding: 0 }}>
                                            <Carousel controls={false} indicators={true}>
                                                <Carousel.Item>
                                                    <Image src={coverPalindromo} width={'100%'} />
                                                    <Carousel.Caption className='text-start'>
                                                        <p className='small'><b>2026</b></p>
                                                        <h4>Palindromo</h4>
                                                        <p className='small'>Esploriamo quello che esiste, anche quando i nostri occhi non riescono a coglierlo.</p>
                                                        <div className='mt-3 mb-3'>
                                                            <Link to="/edition/palindromo" className='link-light small'>
                                                                <u>Visualizza evento</u>
                                                            </Link>
                                                        </div>
                                                    </Carousel.Caption>
                                                </Carousel.Item>
                                                <Carousel.Item>
                                                    <Image src={coverInvisibile} width={'100%'} />
                                                    <Carousel.Caption className='text-start'>
                                                        <p className='small'><b>2025</b></p>
                                                        <h4>Invisibile</h4>
                                                        <p className='small'>Esploriamo quello che esiste, anche quando i nostri occhi non riescono a coglierlo.</p>
                                                        <div className='mt-3 mb-3'>
                                                            <Link to="/edition/invisibile" className='link-light small'>
                                                                <u>Visualizza evento</u>
                                                            </Link>
                                                        </div>
                                                    </Carousel.Caption>
                                                </Carousel.Item>
                                                <Carousel.Item>
                                                    <Image src={coverHeritage} width={'100%'} />
                                                    <Carousel.Caption className='text-start'>
                                                        <p className='small'><b>2024</b></p>
                                                        <h4>Heritage</h4>
                                                        <p className='small'>Da ieri per un domani. Il patrimonio culturale è diventato chiave per ispirare il futuro.</p>
                                                        <div className='mt-3 mb-3'>
                                                            <Link to="/edition/heritage" className='link-light small'>
                                                                <u>Visualizza evento</u>
                                                            </Link>
                                                        </div>
                                                    </Carousel.Caption>
                                                </Carousel.Item>
                                            </Carousel>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-center'>
                        <Col xs={12} lg={5}>
                            <h5 style={{ color: '#eb0028' }}>TEAM</h5>
                            <h3 className='mt-5 mb-5'>La nostra squadra</h3>

                            <p className='lead mb-5'>
                                Il nostro team è una fusione dinamica di
                                giovani talenti provenienti da diverse sfere
                                della culturali e professionali
                            </p>
                            <p>
                                Guidati dalla passione per il territorio, l'innovazione e il
                                cambiamento, insieme, formiamo un gruppo diversificato e
                                complementare, unito dalla missione di ispirare,
                                condividere idee che trasformano il nostro territorio per il
                                meglio.
                            </p>

                            <div className='mt-5 mb-5'>
                                <Link to="/team">
                                    <span className='button-52 m-auto'>
                                        Il Team
                                    </span>
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={6} className='text-center'>
                            <Image src={teamTED} width={'100%'} />
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-0 ps-0 pe-0' style={{ background: '#eb0028' }}>
                <Container fluid="md" className='text-start p-5 text-white'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={2} className='pb-5'>
                            <h5>TEAM</h5>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={3} className='pb-5'>
                            <p className='lead'>Unisciti anche tu alla nostra squadra e costruiamo qualcosa di unico</p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={5} className='pb-5'>
                            <p className='pb-5'>
                                Sostieni concretamente le nostre idee e fatti coinvolgere per diventare un attore principale del cambiamento
                            </p>

                            <div className='mt-5 mb-5'>
                                <Link to="/contact">
                                    <span className='button-52-light m-auto'>
                                        Contatti
                                    </span>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>

        </>
    )

};